export enum KeyConstant {
  shift = 'Shift',
  enter = 'Enter',
}
